import { buildSelector } from '@/shared/lib/store';

export const [useViewerId] = buildSelector(
    (state) => state.viewer?.data?.id || null,
);
